/**
 * Will return the cache options if the cache feature flag is enabled.
 * Otherwise we disable caching.
 */
export const setLoopCacheOptions = ({
  tags,
  revalidate,
}: {
  tags: string[];
  revalidate: number;
}): Partial<RequestInit> => {
  return { cache: "no-store" };
};
